namespace Areas.CustomQuery {
    "use strict";

    let customQueryId: number;
    let canRunQuery: boolean = false;
    let gridIsInitialized: boolean = false;    

    export function getCustomQueryId(): number {
        return customQueryId;
    }

    export function setGridIsInitialized(): void {
        gridIsInitialized = true;
    }

    export function canExecuteQuery(): boolean {
        return canRunQuery;
    }

    export function runQuery(e: any): void {
        if (gridIsInitialized) {
            $("#CustomQueryResultGrid").dxDataGrid("dispose");
        }

        createGridResult();
    }

    export function onCustomQuerySelected(e: any): void {
        const selectedRows = e.component.getSelectedRowsData();
        const rowSelected = selectedRows.length === 1;
        
        if (rowSelected) {
            canRunQuery = true;
            customQueryId = selectedRows[0].customQueryId;
            createParameterForm(selectedRows[0].customQueryFields);
        }
        else
        {
            canRunQuery = false;
        }
    }

}